import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { isDenmarkCountryCode } from 'tradera/localization/countrycode';
import initData from 'tradera/legacy/static/packages/init-data';
import { MAX_SHORT_DESCRIPTION_LENGTH } from 'tradera/apps/syi/containers/short-description';

type ShortDescriptionSlice = {
    shortDescription: string | null;
    validationError?: string | null;
    descriptionLanguageCodeIso2: string | null;
    isDescriptionLanguageCodeIso2ChangeAvailable: boolean;
};
const initialState: ShortDescriptionSlice = {
    shortDescription: null,
    validationError: null,
    descriptionLanguageCodeIso2: null,
    isDescriptionLanguageCodeIso2ChangeAvailable:
        initData &&
        initData.memberCountryCodeIso2 &&
        isDenmarkCountryCode(initData.memberCountryCodeIso2)
};

const getValidationError = (state: ShortDescriptionSlice) => {
    if (!state.shortDescription || state.shortDescription.trim() === '') {
        return 'syi_validation_missing_title';
    }

    if (state.shortDescription.length > MAX_SHORT_DESCRIPTION_LENGTH) {
        return 'syi_shortdescription_error_count_toast';
    }

    if (
        state.isDescriptionLanguageCodeIso2ChangeAvailable &&
        !state.descriptionLanguageCodeIso2
    ) {
        return 'syi_validation_missing_descriptionLanguageCodeIso2';
    }
};

const validate = (state: ShortDescriptionSlice) => ({
    ...state,
    validationError: getValidationError(state)
});

const shortDescriptionSlice = createSlice({
    name: 'shortDescription',
    initialState,
    reducers: {
        setShortDescription: (state, action: PayloadAction<string>) =>
            validate({ ...state, shortDescription: action.payload }),
        resetShortDescription: (state) =>
            validate({ ...state, shortDescription: null }),
        setDescriptionLanguageCodeIso2: (
            state,
            action: PayloadAction<string>
        ) =>
            validate({
                ...state,
                descriptionLanguageCodeIso2: action.payload
            })
    }
});

export const {
    setShortDescription,
    resetShortDescription,
    setDescriptionLanguageCodeIso2
} = shortDescriptionSlice.actions;

export default shortDescriptionSlice.reducer;
